/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';
import page from 'page';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectRoamPlan from 'modules/me/select-roam-plan';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import AnnotatedSection from 'components/annotated-section';
import Notice from 'components/notice';
import { getBusinessName } from 'state/current-user/selectors';

/**
 * Style dependencies
 */
import './styles.scss';


const NewPlan = ({ businessName }) => {
    
    const onSuccessPlanSelect = () => {
        page.redirect('/dashboard/roam');
    };

    return (
        <Box>
            <DocumentHead title='Billing - Tower Systems' />
            <Topbar title='Roam' subTitle={'Hello ' + businessName} selected='roam' />
            <Box marginBottom='xxlarge'>
                <Text className="plan__content">
                Retailer Roam is a tablet app-based POS extension to the Tower Systems Retailer 
                POS software. The app runs on Apple iPad and Android based tablets. 
                It can run connected over WiFi or any other network. It can also run disconnected, 
                syncing when connected again to a network at a later time.
                </Text>
            </Box>
            <Main padding='xxlarge'>
                <Stack space='xxlarge'>
                    <Box>
                        <Heading level='3'>Select a Roam plan</Heading>
                        <Text>
                            *Prices are excluding any applicable discounts. Please click on a plan below to subscribe.
                        </Text>
                    </Box>
                    <Box>
                        <SelectRoamPlan afterSuccess={onSuccessPlanSelect} />
                    </Box>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect((state) => ({businessName: getBusinessName(state),}), {})(NewPlan);
